export default {
  'AI Face Animator': 'AI फेस एनिमेटर',
  'Create incredible facial expressions with brainwashing music, find the magic for fun.': 'ब्रेनवॉशिंग म्यूज़िक के साथ चेहरे के बेहतरीन हाव-भाव बनाएं, मज़े के लिए जादू ढूंढें।',
  'Upload a photo': 'तस्वीर अपलोड करें',
  'please make sure the face in the photos you selected is facing the lens, otherwise it cannot be processed successfully.': 'ध्यान दें: कृपया इस बात का ध्यान रखें कि आपकी चुनी गयी तस्वीरों में चेहरा लेंस के सामने हो, नहीं तो यह सफलतापूर्वक संसाधित नहीं हो पायेगा।',
  'Uploaded successfully!': 'सफलतापूर्वक अपलोड करें!',
  'Please select a template below': 'कृपया नीचे एक टेम्पलेट चुनें',
  'Choose a GIF': 'GIF चुनें',
  'Use this template': 'यह टेम्पलेट प्रयोग करें',
  'Verify successfully! You will': 'सफलतापूर्वक सत्यापित करें! आपको जल्द ही {{email}} के साथ वीडियो मिलेगा।',
  'You will': 'आपको जल्द ही {{email}} के साथ वीडियो मिलेगा।',
  'What you should expect to happen next': 'आपको आगे क्या होने की उम्मीद करनी चाहिए:',
  'We will process your photo into a dynamic video.': 'हम आपकी तस्वीर को गतिशील वीडियो में संसाधित करेंगे।',
  'After processing, we will send the video to your email.': 'संसाधन के बाद, हम वीडियो को आपके ईमेल पर भेजेंगे।',
  'You can check the video in your email.': 'आप अपने ईमेल में वीडियो देख सकते हैं।',
  'Your video will be delivered via email': 'आपका वीडियो ईमेल के माध्यम से भेज दिया जायेगा',
  'It takes 20-30 minutes to synthesize a dynamic video, please be patient. To protect your privacy, the uploaded pictures will be automatically deleted after the processing is over.': 'गतिशील वीडियो बनाने में 20-30 मिनट का समय लगता है, कृपया धैर्य रखें। आपकी गोपनीयता सुरक्षित रखने के लिए, अपलोड की गयी तस्वीरों को संसाधन पूरा होने के बाद अपने आप हटा दिया जायेगा।',
  'Your Email': 'आपका ईमेल',
  'Last Name': 'पहला नाम',
  'First Name': 'अंतिम नाम',
  'Go back': 'पीछे जाएँ',
  'Invalid email address':'अमान्य ईमेल पता',
  'Enter verification code':'सत्यापन कोड डालें',
  'Enter the verification code that we sent to': 'वो सत्यापन कोड डालें, जिसे हमने {{email}} पर भेजा था।',
  'Resend': 'दोबारा भेजें',
  'Verification code': 'सत्यापन कोड',
  'Resend after': '{{num}} सेकंड के बाद दोबारा भेजें',
  'The verification code is invalid. You can request a new one.': 'सत्यापन कोड अमान्य है। आप नए कोड का अनुरोध कर सकते हैं।',
  'Synthesize Video': 'वीडियो बनाएं',
  'Too many attempts, please try again later.': 'कई सारे प्रयास। कृपया बाद में दोबारा प्रयास करें।',
}